import { useMemo } from 'react'
import { useSelector } from 'react-redux'
import { selectMailbox } from 'selectors/mailboxes_base'
import { selectTicketSearchTotalCountsByQueryId } from 'selectors/search'

export const useMailboxAllTicketsCount = mailboxId => {
  const mailbox = useSelector(state => selectMailbox(state, mailboxId))
  const tickeSearchTotalCountsByQueryId = useSelector(
    selectTicketSearchTotalCountsByQueryId
  )
  const folderIds = useMemo(
    () => {
      if (!mailbox) {
        return []
      }

      const regularFolderIds = mailbox.folders.map(
        folderId => `inbox:${mailbox.id} folder:${folderId}`
      )
      const customFolderIds = [
        `inbox:${mailbox.id} is:deleted`,
        `inbox:${mailbox.id} is:open`,
      ]
      return [...regularFolderIds, ...customFolderIds]
    },
    [mailbox]
  )
  const total = useMemo(
    () => {
      let count = 0

      folderIds.forEach(folderId => {
        if (tickeSearchTotalCountsByQueryId[folderId]) {
          count += tickeSearchTotalCountsByQueryId[folderId]
        }
      })

      return count
    },
    [folderIds, tickeSearchTotalCountsByQueryId]
  )

  return total
}
